import { Pipe, PipeTransform } from '@angular/core';

import { checkRegionForParameterset } from '../constants/constants';

@Pipe({ name: 'checkRegionForParameterset' })
export class CheckRegionForParametersetPipe implements PipeTransform {
  transform(region: string, windpowerMode: boolean, solarpowerMode: boolean) {
    return checkRegionForParameterset(region, windpowerMode, solarpowerMode);
  }
}
